import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip-info-despagination',
  templateUrl: './tooltip-info-despagination.component.html',
  styleUrls: ['./tooltip-info-despagination.component.scss'],
  standalone: false
})
export class TooltipInfoDespaginationComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
